import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { WelcomePage } from "@/features/portalmore/WelcomePage";

const search = z.object({
  step: z.string().optional(),
});

/** Portal first-login welcome wizard (P109). The current step kind is in `step`. */
export const Route = createFileRoute("/portal/welcome")({
  validateSearch: search,
  component: () => <WelcomePage search={Route.useSearch()} />,
});
